import { useApp } from '../context/AppContext';
import React, { useState, useEffect, useCallback } from 'react';
const API = '/api/app';
const inputStyle = { background:'var(--input-bg)', border:'1px solid var(--border)', borderRadius:8, padding:'8px 12px', color:'var(--text-primary)', fontSize:13, width:'100%', boxSizing:'border-box' };

const STATUS_COLORS = {
  pending:   { bg:'rgba(255,165,0,0.12)',  color:'#FFA500' },
  accepted:  { bg:'rgba(167,244,50,0.12)', color:'#A7F432' },
  rejected:  { bg:'rgba(255,80,80,0.12)',  color:'#ff6b6b' },
  confirmed: { bg:'rgba(33,150,243,0.12)', color:'#2196F3' },
  cancelled: { bg:'rgba(150,150,150,0.12)',color:'#aaa' },
};

function Badge({ status }) {
  const s = STATUS_COLORS[status] || STATUS_COLORS.pending;
  return <span style={{ background:s.bg, color:s.color, borderRadius:20, padding:'2px 10px', fontSize:11, fontWeight:600, textTransform:'capitalize' }}>{status}</span>;
}

function RespondModal({ request, onClose, onDone }) {
  const { token } = useApp();
  const [decision, setDecision] = useState('accept');
  const [price, setPrice] = useState(request.pitch?.price || '');
  const [currency, setCurrency] = useState(request.pitch?.currency || 'AED');
  const [message, setMessage] = useState('');
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    setSaving(true);
    try {
      const body = decision === 'accept'
        ? { decision: 'accept', proposedPrice: parseFloat(price), proposedCurrency: currency, responseMessage: message }
        : { decision: 'reject', rejectionReason: reason };
      const res = await fetch(`${API}/organizer-pitch-requests/${request.id}/respond`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
      });
      const d = await res.json();
      if (res.ok || d.success) { onDone(); onClose(); }
      else { alert(d.message || d.data?.message || 'Failed to respond'); }
    } catch(e) {
      alert('Network error: ' + e.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.85)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', backdropFilter:'blur(4px)' }}>
      <div style={{ background:'#1a2310', borderRadius:16, padding:28, width:480, maxWidth:'95vw', border:'1px solid var(--border)', boxShadow:'0 20px 60px rgba(0,0,0,0.8)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
          <span style={{ fontWeight:700, fontSize:16 }}>Respond to Pitch Request</span>
          <button onClick={onClose} style={{ background:'none', border:'none', color:'var(--text-dim)', cursor:'pointer', fontSize:18 }}>✕</button>
        </div>

        <div style={{ background:'rgba(255,255,255,0.03)', borderRadius:10, padding:14, marginBottom:16, fontSize:13 }}>
          <div style={{ fontWeight:600, marginBottom:6 }}>{request.pitch?.name || 'Pitch'}</div>
          <div style={{ color:'var(--text-dim)', fontSize:12 }}>
            {request.proposedDate} · {request.startTime} · {request.duration}min · {request.format} · {request.expectedPlayers} players
          </div>
          {request.notes && <div style={{ color:'var(--text-dim)', fontSize:12, marginTop:4 }}>Note: {request.notes}</div>}
        </div>

        <div style={{ display:'flex', gap:8, marginBottom:16 }}>
          <button onClick={() => setDecision('accept')} style={{ flex:1, padding:'8px 0', borderRadius:8, border:'none', cursor:'pointer', fontWeight:600, fontSize:13,
            background: decision === 'accept' ? '#a7f432' : 'rgba(255,255,255,0.05)', color: decision === 'accept' ? '#0f1a10' : 'var(--text-dim)' }}>
            Accept
          </button>
          <button onClick={() => setDecision('reject')} style={{ flex:1, padding:'8px 0', borderRadius:8, border:'none', cursor:'pointer', fontWeight:600, fontSize:13,
            background: decision === 'reject' ? 'rgba(255,80,80,0.2)' : 'rgba(255,255,255,0.05)', color: decision === 'reject' ? '#ff6b6b' : 'var(--text-dim)' }}>
            Reject
          </button>
        </div>

        {decision === 'accept' && (
          <>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:12 }}>
              <div>
                <label style={{ fontSize:11, color:'var(--text-dim)', display:'block', marginBottom:4, textTransform:'uppercase' }}>Price</label>
                <input type="number" style={inputStyle} value={price} onChange={e => setPrice(e.target.value)} placeholder="e.g. 350" />
              </div>
              <div>
                <label style={{ fontSize:11, color:'var(--text-dim)', display:'block', marginBottom:4, textTransform:'uppercase' }}>Currency</label>
                <select style={inputStyle} value={currency} onChange={e => setCurrency(e.target.value)}>
                  {['AED','USD','GBP','EUR','NGN'].map(c => <option key={c}>{c}</option>)}
                </select>
              </div>
            </div>
            <div style={{ marginBottom:16 }}>
              <label style={{ fontSize:11, color:'var(--text-dim)', display:'block', marginBottom:4, textTransform:'uppercase' }}>Message (optional)</label>
              <textarea style={{ ...inputStyle, fontFamily:'inherit', resize:'vertical' }} rows={2} value={message} onChange={e => setMessage(e.target.value)} placeholder="e.g. Please arrive 10 mins early" />
            </div>
          </>
        )}

        {decision === 'reject' && (
          <div style={{ marginBottom:16 }}>
            <label style={{ fontSize:11, color:'var(--text-dim)', display:'block', marginBottom:4, textTransform:'uppercase' }}>Rejection Reason</label>
            <textarea style={{ ...inputStyle, fontFamily:'inherit', resize:'vertical' }} rows={2} value={reason} onChange={e => setReason(e.target.value)} placeholder="e.g. Already booked at this time" />
          </div>
        )}

        <button onClick={submit} disabled={saving} style={{ width:'100%', background: decision === 'accept' ? '#a7f432' : 'rgba(255,80,80,0.2)', color: decision === 'accept' ? '#0f1a10' : '#ff6b6b', border:'none', borderRadius:8, padding:'10px 0', cursor:'pointer', fontWeight:700, fontSize:14 }}>
          {saving ? 'Saving...' : decision === 'accept' ? 'Accept Request' : 'Reject Request'}
        </button>
      </div>
    </div>
  );
}

export default function PitchRequests({ toast }) {
  const { token } = useApp();
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('pending');
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [selected, setSelected] = useState(null);
  const limit = 20;

  const load = useCallback(async (p = 1, s = status) => {
    setLoading(true);
    try {
      const qs = new URLSearchParams({ limit, page: p, ...(s && s !== 'all' && { status: s }) });
      const res = await fetch(`${API}/organizer-pitch-requests?${qs}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const d = await res.json();
      setRequests(d.data?.requests || d.requests || d.data || []);
      setTotal(d.data?.total || d.total || 0);
    } catch(e) { toast?.('Failed to load requests'); }
    finally { setLoading(false); }
  }, [status, toast]);

  useEffect(() => { load(1, status); setPage(1); }, [status]);

  return (
    <div style={{ padding:24 }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <div>
          <h2 style={{ margin:0, fontSize:22, fontWeight:700 }}>Pitch Booking Requests</h2>
          <p style={{ margin:'4px 0 0', color:'var(--text-dim)', fontSize:13 }}>Incoming requests for your pitches</p>
        </div>
      </div>

      <div style={{ display:'flex', gap:8, marginBottom:20, flexWrap:'wrap' }}>
        {['pending','accepted','rejected','confirmed','cancelled','all'].map(s => (
          <button key={s} onClick={() => setStatus(s)} style={{
            padding:'6px 16px', borderRadius:20, border:'none', cursor:'pointer', fontSize:12, fontWeight:600, textTransform:'capitalize',
            background: status === s ? '#a7f432' : 'rgba(255,255,255,0.06)',
            color: status === s ? '#0f1a10' : 'var(--text-dim)',
          }}>{s}</button>
        ))}
      </div>

      {loading ? (
        <div style={{ textAlign:'center', padding:60, color:'var(--text-dim)' }}>Loading...</div>
      ) : requests.length === 0 ? (
        <div style={{ textAlign:'center', padding:60, color:'var(--text-dim)' }}>No {status} requests found</div>
      ) : (
        <>
          <div style={{ background:'var(--card-bg)', borderRadius:12, border:'1px solid var(--border)', overflow:'hidden' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
              <thead>
                <tr style={{ background:'rgba(255,255,255,0.03)', borderBottom:'1px solid var(--border)' }}>
                  {['Pitch','Organizer','Date & Time','Format','Players','Status','Action'].map(h => (
                    <th key={h} style={{ padding:'12px 14px', textAlign:'left', fontWeight:600, fontSize:11, textTransform:'uppercase', color:'var(--text-dim)' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {requests.map((r, i) => (
                  <tr key={r.id} style={{ borderBottom:'1px solid rgba(255,255,255,0.04)', background: i%2===0 ? 'transparent' : 'rgba(255,255,255,0.01)' }}>
                    <td style={{ padding:'11px 14px', fontWeight:600 }}>
                      <div>{r.pitch?.name || '—'}</div>
                      <div style={{ color:'var(--text-dim)', fontSize:11 }}>{r.pitch?.city || ''}</div>
                    </td>
                    <td style={{ padding:'11px 14px', color:'var(--text-dim)' }}>
                      <div>{r.organizer?.user?.firstName} {r.organizer?.user?.lastName}</div>
                      <div style={{ fontSize:11 }}>{r.organizer?.user?.email}</div>
                    </td>
                    <td style={{ padding:'11px 14px' }}>
                      <div>{r.proposedDate}</div>
                      <div style={{ color:'var(--text-dim)', fontSize:11 }}>{r.startTime} · {r.duration}min</div>
                    </td>
                    <td style={{ padding:'11px 14px' }}>{r.format || '—'}</td>
                    <td style={{ padding:'11px 14px' }}>{r.expectedPlayers || '—'}</td>
                    <td style={{ padding:'11px 14px' }}><Badge status={r.status} /></td>
                    <td style={{ padding:'11px 14px' }}>
                      {r.status === 'pending' ? (
                        <button onClick={() => setSelected(r)} style={{ background:'rgba(167,244,50,0.1)', color:'#a7f432', border:'1px solid rgba(167,244,50,0.2)', borderRadius:6, padding:'4px 12px', cursor:'pointer', fontSize:12, fontWeight:600 }}>
                          Respond
                        </button>
                      ) : (
                        <div style={{ fontSize:11, color:'var(--text-dim)' }}>
                          {r.proposedPrice ? `${r.proposedCurrency} ${r.proposedPrice}` : r.rejectionReason ? r.rejectionReason.slice(0,30) : '—'}
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginTop:16 }}>
            <span style={{ color:'var(--text-dim)', fontSize:13 }}>{total} total requests</span>
            <div style={{ display:'flex', gap:8 }}>
              <button onClick={() => { setPage(p => p-1); load(page-1); }} disabled={page<=1}
                style={{ background:'var(--card-bg)', border:'1px solid var(--border)', color:'var(--text-primary)', borderRadius:8, padding:'6px 14px', cursor:'pointer', fontSize:13 }}>← Prev</button>
              <button onClick={() => { setPage(p => p+1); load(page+1); }} disabled={page*limit>=total}
                style={{ background:'var(--card-bg)', border:'1px solid var(--border)', color:'var(--text-primary)', borderRadius:8, padding:'6px 14px', cursor:'pointer', fontSize:13 }}>Next →</button>
            </div>
          </div>
        </>
      )}

      {selected && <RespondModal request={selected} onClose={() => setSelected(null)} onDone={() => load(page)} />}
    </div>
  );
}
